.text {
    margin-top: 20px;
}

.button {
    composes: space-above from '../../auth-shared.module.css';
}

.submit {
    margin-bottom: 8px;
}
